<template>
  <el-dialog :title="title" :visible="visible" width="560px" :before-close="handleClose">
    <div class="modifies_dialog">
      <el-form :model="form" ref="form" :rules="rules" label-width="125px">
        <template>
          <el-form-item  prop="oldPassword">
            <template slot="label">
              <div class="form-item-label">
                <span>手机号</span>
                <span>Phone number</span>
              </div>
            </template>
            <span class="phone_c">
              <span>+</span>
              <span>{{ memberInfo.mobileCountryCode }}</span>
            </span>
            <span>{{ memberInfo.mobileLike }}</span>
          </el-form-item>
          <el-form-item prop="code">
            <template slot="label">
              <div class="form-item-label">
                <span>验证码</span>
                <span>verification code</span>
              </div>
            </template>
            <el-input v-model="form.code" :maxlength="100" placeholder="请填写验证码 Verification code">
              <template slot="append">
                <div
                  @click.stop="getVerifyCode"
                  class="form-item-label verification-code"
                  :class="{
                    'disabled-btn': disabledBtn,
                    'verify-btn': !disabledBtn,
                  }">
                  <span>{{ btnTitle }}</span>
                  <span>{{btnTitleEn}}</span>

                </div>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="fillPassword">
            <template slot="label">
              <div class="form-item-label">
                <span>设置密码</span>
                <span>Set password</span>
              </div>
            </template>
            <el-input v-model="form.fillPassword" :maxlength="100" placeholder="请填写新密码 Please fill in a new password"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="surePassword">
            <template slot="label">
              <div class="form-item-label">
                <span>确认密码</span>
                <span>Confirm Password</span>
              </div>
            </template>
            <el-input v-model="form.surePassword"
                      :maxlength="100"
                      placeholder="请确认新密码 Please confirm new password"></el-input>
          </el-form-item>
        </template>
      </el-form>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="conserves">保 存 Save</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    infoList: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      rules: {
        code: [{ required: true, message: "请填写验证码", trigger: "blur" }],
        fillPassword: [{ required: true, message: "请填写新密码", trigger: "blur" }],
        surePassword: [{ required: true, message: "请确认新密码", trigger: "blur" }],
      },
      form: {
        code: "",
        fillPassword: "",
        surePassword: "",
      },
      memberInfo: {},
      btnTitle: "获取验证码",
      btnTitleEn: "Get verification code",
      disabledBtn: false,
    };
  },
  computed: {},
  created() {},
  async mounted() {},
  methods: {
    handleClose(done) {
      this.$emit("update:visible", false);
      done();
    },
    async conserves() {
      if (this.form.code == "" || this.form.fillPassword == "" || this.form.surePassword == "") return false;
      this.$emit("dialogCallbackRetrieve", this.form);
    },
    //获取验证码
    async getVerifyCode() {
      try {
        let { data } = await this.$api.getMoneybagSms();
        localStorage.setItem("smsCodeFlowNo", data.smsCodeFlowNo);
        this.$message.success("发送验证码成功");
        this.validateBtn();
      } catch (error) {
        console.log("error", error);
      }
    },
    //倒计时
    validateBtn() {
      //倒计时
      let time = 60;
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer);
          this.disabledBtn = false;
          this.btnTitle = "获取验证码";
          this.btnTitleEn="Get verification code";
        } else {
          this.btnTitle = time + "s";
          this.btnTitleEn=""
          this.disabledBtn = true;
          time--;
        }
      }, 1000);
    },
  },
  watch: {
    infoList: {
      handler(val) {
        if (val) {
          this.memberInfo = {
            mobileCountryCode: val.mobileCountryCode ?? "",
            mobileLike: val.mobileLike ?? "",
          };
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss">
.modifies_dialog {
  .phone_c {
    padding-right: 10px;
    border-right: 2px solid #999999;
    margin-right: 10px;
  }
  .disabled-btn {
    color: #999;
    width: 100%;
    height: 100%;
  }
  .verify-btn {
    cursor: pointer;
    color: #4c71fe;
    width: 100%;
    height: 100%;
  }
}
.form-item-label{
  position: relative;
  box-sizing: border-box;
  display: flex;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  flex-direction: column;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  align-items: flex-end;
  span{
    line-height: 1.2rem;
  }
}
.verification-code{
  width: 128px;
  align-items: center;
  justify-content: center;
}
</style>
